import { colors } from "pages/Home/Home.styles";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";

export const SkeletonText = ({ height, count = 1 }) => {
  return (
    <SkeletonTheme
      baseColor={colors.background}
      highlightColor={colors.whiteOpacity}
    >
      <Skeleton count={count} height={height} />
    </SkeletonTheme>
  );
};
